import { render, staticRenderFns } from "./TerritorioParaguai.vue?vue&type=template&id=4a23937e&lang=pug"
import script from "./TerritorioParaguai.vue?vue&type=script&lang=js"
export * from "./TerritorioParaguai.vue?vue&type=script&lang=js"
import style0 from "./TerritorioParaguai.vue?vue&type=style&index=0&id=4a23937e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports